module.exports = __webpack_public_path__ + "img/2.03.thmb.xs.ede9c6f2.jpg";